import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from '@/components/ModalSheet'
import { Form } from '@/components/Form'
import { Button } from '@/components/Button'

export interface AddManualInvoiceDialogProps {
  showing: boolean
  isAddPending: boolean
  onClose: () => unknown
  onAdd: () => unknown
  children?: ReactNode
}

export function AddManualInvoiceDialog({
  showing,
  isAddPending,
  onClose,
  onAdd,
  children,
}: AddManualInvoiceDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isAddPending ? undefined : onClose}
    >
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>Add manual invoice to job</ModalSheetTitle>
      </ModalSheetHeader>

      <ModalSheetContent>
        <ModalSheetContentBlock expanded>
          <Form>{children}</Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            isDisabled={isAddPending}
            onPress={onClose}
            testId="add-manual-invoice-close-button"
          />
          <Button
            label="Add Invoice"
            variant="primary"
            isPending={isAddPending}
            testId="add-manual-invoice-submit-button"
            onPress={onAdd}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
